import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable, of } from "rxjs";
import { environment } from "src/environments/environment";
import { LocalStorageService } from "../utils/LocalStorage";
import { GeneralService } from "./general.service";
import { catchError } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class EndpointsService {
  private host = environment.apiUrl;
  tokenGenerated = new BehaviorSubject<string>("");
  httpStatus = "firstload";
  err = new BehaviorSubject<string>("");

  customerUrl = `${this.host}/admin/customers`;
  productUrl = `${this.host}/admin/products`;
  otherProductImgUrls = `${this.host}/admin/products/images`;
  categoryUrl = `${this.host}/admin/category`;
  orderUrl = `${this.host}/admin/orders`;
  eventUrl = `${this.host}/admin/events`;
  frameUrl = `${this.host}/admin/frames`;
  portfolioUrl = `${this.host}/admin/portfolio`;
  portfolioDomainUrl = `${this.host}/admin/portfolio/domain`;
  portfolioImgUrl = `${this.host}/admin/portfolio/images`;
  eventUsersUrl = `${this.host}/admin/event/users`;
  customOrderUrl = `${this.host}/admin/customOrders`;
  couponUrl = `${this.host}/coupons`;
  newsletterUrl = `${this.host}/newsletter`;
  teamsUrl = `${this.host}/teams`;
  artisteUrl = `${this.host}/artiste`;
  bannerCarouselUrl = `${this.host}/bannerCarousel`;

  constructor(private http: HttpClient, private storeSrv: LocalStorageService, private gs: GeneralService) {
    const token = JSON.parse(
      this.storeSrv.getFromLocalStorage('AdminUsertoken')
    );
    this.tokenGenerated.next(token);
  }


  // Handle Errors
  public handleError = (error: any): Observable<any> => {
    let message = "";
    if (error) {
      message = error.error.error.message
      this.err.next(message);
      this.gs.sweetAlertError(message);
    }
    return of(null);
  };

  create(url, payload) {
    try {
      return this.http.post(url, payload).pipe(catchError(this.handleError));
    } catch (error) {
      this.handleError;
    }
  }

  fetchAll(url) {
    try {
      return this.http.get(url).pipe(catchError(this.handleError));
    } catch (error) {
      this.handleError;
    }
  }

  fetchOne(url, id) {
    try {
      return this.http.get(`${url}/${id}`).pipe(catchError(this.handleError));
    } catch (error) {
      this.handleError;
    }
  }

  updateDetails(url, id, payload) {
    try {
      return this.http.patch(
        `${url}/${id}`,
        payload
      ).pipe(catchError(this.handleError));
    } catch (error) {
      this.handleError;
    }
  }

  deleteDetails(url, id) {
    try {
      return this.http.delete(`${url}/${id}`).pipe(catchError(this.handleError));
    } catch (error) {
      this.handleError;
    }
  }



  // SignUp and Login
  registerAdmin(payload) {
    try {
      return this.http.post('/admin', payload).pipe(catchError(this.handleError));
    } catch (error) {
      this.handleError;
    }
  }

  fetchAdmin(userId) {
    try {
      return this.http.get(`${this.host}/admin/${userId}`).pipe(catchError(this.handleError));
    } catch (error) {
      this.handleError;
    }
  }

  updateAdmin(userId, payload) {
    try {
      return this.http.patch(
        `${this.host}/admin/${userId}`,
        payload
      ).pipe(catchError(this.handleError));
    } catch (error) {
      this.handleError;
    }
  }

  loginAdmin(payload) {
    try {
      return this.http.post(`${this.host}/admin/login`, payload).pipe(catchError(this.handleError));
    } catch (error) {
      this.handleError;
    }
  }
}
